<template>
  <div style="overflow-y: scroll;" class="dark-home" :class="{ 'dark-mode': isDarkMode }">
    <link rel="stylesheet" :href="themeLink" id="theme-stylesheet">

    <div v-if="!selectedSite" class="home" id="header-nav">
      <div :class="['profile', { 'profile-no-button': !showChangeSiteButton }]">
        <div class="initials">{{ nameInitials ? nameInitials : "👤" }}</div>
        <div class="profile-info">
          <div class="profile-text">{{ userName ? userName : "👤" }}</div>
          <div class="date">{{ date }}</div>
        </div>
        <div class="site_buttons">
  <label class="switch">
    <input
      type="checkbox"
      id="checkbox"
      :checked="!isDarkMode"
      @change="toggleDarkMode"
    />
    <span class="theme-slider">
      <div class="star star_1"></div>
      <div class="star star_2"></div>
      <div class="star star_3"></div>
      <svg viewBox="0 0 16 16" class="cloud_1 cloud">
        <path
          transform="matrix(.77976 0 0 .78395-299.99-418.63)"
          fill="#fff"
          d="m391.84 540.91c-.421-.329-.949-.524-1.523-.524-1.351 0-2.451 1.084-2.485 2.435-1.395.526-2.388 1.88-2.388 3.466 0 1.874 1.385 3.423 3.182 3.667v.034h12.73v-.006c1.775-.104 3.182-1.584 3.182-3.395 0-1.747-1.309-3.186-2.994-3.379.007-.106.011-.214.011-.322 0-2.707-2.271-4.901-5.072-4.901-2.073 0-3.856 1.202-4.643 2.925"
        ></path>
      </svg>
    </span>
  </label>
</div>

      </div>
      <div v-if="isDarkMode" class="header-content">
        <div class="centralize-text">
          Centralize, <span class="green-text">Optimize,</span> <br> Revolutionize
        </div>
      </div>
    </div>

    <div v-if="!selectedSite && !isDarkMode" class="carousel-container">
      <Carousel
        ref="carousel"
        :itemsToShow="1"
        :itemsToScroll="1"
        :autoplay="0"
        :loop="false"
        v-model="currentSlide"
      >
        <Slide v-for="(slide, index) in slides" :key="index">
          <div class="slide">
            <div class="slide-background" :style="{ backgroundImage: 'url(' + slide.image + ')' }"></div>
            <div v-if="index === 0" class="slide-content layout1">
              <div class="slide-text"><img src="../../images/tri-new.svg" alt=""></div>
              <div class="slide-text">Centralize, <span>Optimize,</span> Revolutionize</div>
            </div>
            <div v-else-if="index === 1" class="slide-content layout2">
              <div class="left-content">
                <div class="smoke_image">
                  <img src="../../images/smoke.svg" class="slide-image-left"/>
                </div>
                <div class="slide-text-left">{{ carbonEmission ? carbonEmission : '0' }}t</div>
              </div>
              <div class="right-content">
                <div class="slide-text-right">Carbon Emission</div>
                <div class="slide-text-right partner">
                  We partner with environmental non-profits and tree-planting organizations globally so you can offset your carbon emissions in your own backyard.
                </div>
              </div>
            </div>
            <div v-else class="slide-content layout3">
              <div class="left-content">
                <div class="smoke_image leaf">
                  <img src="../../images/leaf.svg" class="slide-image-left"/>
                </div>
                <div class="slide-text-left">{{ totalPlantedTrees ? totalPlantedTrees : '0' }}</div>
              </div>
              <div class="right-content">
                <div class="slide-text-right planting">Planting Green <br> Growing Life.</div>
                <div class="slide-text-right partner"></div>
              </div>
            </div>
          </div>
        </Slide>
      </Carousel>
      <div class="dots">
        <span
          class="dot"
          :class="{ active: currentSlide === index }"
          v-for="(slide, index) in slides"
          :key="index"
          @click="goToSlide(index)"
        ></span>
      </div>
    </div>

    <div class="dark_graph_container">
      <div v-if="!selectedSite" style="padding: 0 20px;" class="power_home">
        <div class="power_input">
          <p class="power_intro">Total Power Output</p>
          <p class="power_date">{{ tg === 0 ? 'Yesterday' : date }}</p>
          <p class="power_date" style="margin-bottom: 0.5rem;">kW</p>
          <div>
            <BarChart :unit="'kW'" :isDarkMode="isDarkMode" :data="powerData" :labels="genLabels" v-if="loaded" />
            <p v-else>Loading...</p>
          </div>
        </div>
      </div>
      <button @click="redirectToAddSite" class="add_site_btn"> + Add Site</button>

      <div v-if="!selectedSite" style="padding: 15px 20px 0;">
        <p class="status_top">Status</p>
        <div class="status">
          <div class="status-item">
            <p class="units_today">{{ tg ? tg : 0 }} <span v-if="tg">{{ tgUnit }}</span></p>
            <p class="today">Today</p>
            <div class="border-line"></div>
          </div>
          <div class="status-item">
            <p class="units_today">{{ yg ? yg : 0 }} <span v-if="yg">{{ ygUnit }}</span></p>
            <p class="today">Yesterday</p>
            <div class="border-line"></div>
          </div>
          <div class="status-item">
            <p class="units_today">{{ atg ? atg : 0 }} <span>{{ totalGenerationUnit }}</span></p>
            <p class="today">{{ totalGenerationLabel ? totalGenerationLabel : 'This month' }}</p>
            <div class="border-line"></div>
          </div>
        </div>
        <div class="printing_weather">
          <div class="weather_intro">
            <h2 class="impact">Your Overall Impact</h2>
            <p class="impact">{{ date }}</p>
          </div>
          <div class="weather-card-container">
            <div class="weather-card">
              <div class="weather-card-left">
                <div class="weather-image-container" :style="{ backgroundColor: '#00278B' }">
                  <img src="../../images/clouds1.svg" alt="Image 1"/>
                </div>
              </div>
              <div class="weather-card-right">
                <p class="weather-main-text">{{ temperature ? `${temperature}°` : "N/A" }}</p>
                <p class="weather-sub-text">Weather</p>
              </div>
            </div>
            <div class="weather-card">
              <div class="weather-card-left">
                <div class="weather-image-container" :style="{ backgroundColor: '#011CAA' }">
                  <img src="../../images/solar-weather.svg" alt="Image 4"/>
                </div>
              </div>
              <div class="weather-card-right">
                <p class="weather-main-text">{{ capacity ? capacity : "N/A" }}
                  <span v-if="capacity" style="font-size: 10px">{{ sizeUnit ? sizeUnit : "kW" }}</span>
                </p>
                <p class="weather-sub-text">Solar</p>
              </div>
            </div>
            <div class="weather-card">
              <div class="weather-card-left">
                <div class="weather-image-container" :style="{ background: 'linear-gradient(to bottom, #00F2B2, #013426)' }">
                  <img src="../../images/ruppee.svg" alt="Image 3"/>
                </div>
              </div>
              <div class="weather-card-right">
                <p class="weather-main-text">{{ ats ? ats : "N/A" }}<span v-if="ats">{{ savingSuffix }}</span></p>
                <p class="weather-sub-text">Savings</p>
              </div>
            </div>
            <div class="weather-card">
              <div class="weather-card-left">
                <div class="weather-image-container" :style="{ backgroundColor: '#00F2B2' }">
                  <img src="../../images/weather-ev.svg" alt="Image 2"/>
                </div>
              </div>
              <div class="weather-card-right">
                <p class="weather-main-text">N/A</p>
                <p class="weather-sub-text">EV</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import BarChart from '../components/BarChart.vue';
import Slide1 from '../../images/slide_bg1.svg';
import Slide2 from '../../images/slide_bg_2.svg';
import Slide3 from '../../images/slide_bg_3.svg';
import DataService from '@/services/data.service';
import UserService from '@/services/user.service';
import changeUnitUtils from '@/utils/changeUnitUtils';
import router from "@/router";
import SiteList from '@/components/SiteList.vue'; 

export default {
  components: { Carousel, Slide, BarChart, SiteList },
  data() {
    return {
      selectedSite: false,
      showChangeSiteButton: false,
      isDarkMode: false,
      slides: [
        { image: Slide1, text1: 'Slide 1 Text 1', text2: 'Slide 1 Text 2' },
        { image: Slide2, text: 'Slide 2 Text' },
        { image: Slide3, text: 'Slide 3 Text' },
      ],
      currentSlide: 0,
      tg: 0,
      yg: 0,
      atg: 0,
      ats: 0,
      savingSuffix: '',
      capacity: 0,
      sizeUnit: 'kW',
      temperature: 0,
      totalGenerationLabel: 'This month',
      totalGenerationUnit: 'kWh',
      tgUnit: 'kWh',
      ygUnit: 'kWh',
      date: "",
      userName: "App User",
      user: null,
      nameInitials: "",
      loaded: false,
      imei: "",
      carbonEmission: 0,
      totalPlantedTrees: 0,
      totalSites:null,
      emits: ["changeView", "toggleDarkMode"],
      powerData:[],
      genLabels: [],
      offset: 0, // Add offset property
      limit: 10, // Add limit property
    };
  },
  computed: {
    themeLink() {
      return this.isDarkMode ? '/dark-theme.css' : '';
    }
  },
  watch: {
    isDarkMode(newVal) {
      console.log('Dark mode changed:', newVal);
      const themeLinkElement = document.getElementById('theme-stylesheet');
      if (themeLinkElement) {
        if (newVal) {
          themeLinkElement.href = this.themeLink;
        } else {
          themeLinkElement.href = '';
        }
      } else {
        console.error('Theme stylesheet link element not found');
      }
      document.body.classList.toggle('dark-mode', newVal);
      localStorage.setItem('darkMode', newVal);
      this.$emit('toggleDarkMode', newVal); // Emit the event
    }
  },
  async mounted() {
    const savedDarkMode = localStorage.getItem('darkMode');
    if (savedDarkMode === 'true') {
      this.isDarkMode = true;
      document.body.classList.add('dark-mode');
    }

    try {
      this.user = await UserService.getCurrentUser();
      await this.updatePermissions(this.user);
      this.imei = await this.extractImei();
      this.userName = this.user?.name?.str;
      if (this.userName) {
        this.userName = this.userName.split(' ').slice(0, 2).join(' ');
        const names = this.userName.split(" ");
        this.nameInitials = names[0].charAt(0);
        if (names.length > 1) {
          this.nameInitials += names[names.length - 1].charAt(0);
        }
      }
      await this.fetchNodeDetails();  // Inserted function here

      const result = await DataService.getData(this.imei);
      if (result) {
        this.loaded = true;
        [this.tg, this.tgUnit] = changeUnitUtils.getUnitAndVal(result.todayTotal);
        [this.yg, this.ygUnit] = changeUnitUtils.getUnitAndVal(result.yesterdayTotal);
        [this.atg, this.totalGenerationUnit] = changeUnitUtils.getUnitAndVal(result.totalGenerationTracked);
        this.ats = this.getTotalSavings(result.totalSavings);
        this.date = result.dateToday;
        this.temperature = result.temperature;
        this.capacity = this.getSize(result.plantSize);
        this.totalGenerationLabel = result.totalGenerationLabel;
        this.carbonEmission = result.carbonEmission;
        this.totalPlantedTrees = result.totalPlantedTrees;
        this.powerData=result.todayPowerGraph;
        this.genLabels=result.genLabels;
      }
    } catch (error) {
      console.log(error);
    }
    
  },
  methods: {
    redirectToAddSite() {
      router.push('/address');
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
    },
    async fetchNodeDetails() {
      try {
        const cohortIds = this.$store.getters.cohortIds;
        const cohortNodes = await DataService.listNodeDetail(cohortIds, this.offset, this.limit);
        const userNodes = await UserService.getUserNodeDetail();
        const mergedNodes = [...userNodes, ...cohortNodes].reduce(
          (acc, node) => {
            acc.set(node.id, node);
            return acc;
          },
          new Map()
        );
        this.totalSites= Array.from(mergedNodes.values());

        if (cohortNodes && cohortNodes.length !== undefined) {
          // Check if there are more nodes to load
          this.hasMoreNodes = cohortNodes.length === this.limit;

          // Show or hide the "Change Site" button based on the length of cohortNodes
          this.showChangeSiteButton = this.totalSites.length > 1;
          this.$store.dispatch("updateIsMultiSite", this.showChangeSiteButton);
        } else {
          console.error("cohortNodes is undefined or does not have a length property");
        }
      } catch (error) {
        console.error("Error in fetchNodeDetails:", error);
      }
    },
    changeView() {
      this.$emit("changeView", "SitePage");
    },
    handleSiteSelected(site) {
      this.selectedSite = false;
      // Update the home page state based on the selected site
      this.updateHomePageData(site);
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    addSite() {
      router.push('/address');
    },
    updateHomePageData(site) {
      // Update the home page data based on the selected site
      this.userName = site.name.str;
      this.nameInitials = site.name.str.split(' ').map(name => name.charAt(0)).join('');
      this.date = site.dateToday;
      [this.tg, this.tgUnit] = changeUnitUtils.getUnitAndVal(site.todayTotal);
      [this.yg, this.ygUnit] = changeUnitUtils.getUnitAndVal(site.yesterdayTotal);
      [this.atg, this.totalGenerationUnit] = changeUnitUtils.getUnitAndVal(site.totalGenerationTracked);
      this.ats = this.getTotalSavings(site.totalSavings);
      this.temperature = site.temperature;
      this.capacity = this.getSize(site.plantSize);
      this.totalGenerationLabel = site.totalGenerationLabel;
    },
    async updatePermissions(currentUser) {
      let orgOlc = currentUser.organizations || [];
      let orgFilterOlc = [];
      for (let i = 0; i < orgOlc.length; i++) {
        let olc = orgOlc[i].org.olc;
        let olcAllow = olc.allow || [];
        let olcDeny = olc.deny || [];

        let filteredOrgAllow = olcAllow.filter(
          (allowItem) =>
            !olcDeny.some(
              (denyItem) => denyItem.condition === allowItem.condition
            )
        );

        orgFilterOlc.push(...filteredOrgAllow);
      }
      // userOlcAllow + orgFilterOlc => combinedFilteredOlc
      let userOlc = currentUser.olc || {};
      let userAllow = userOlc.allow || [];
      let combinedFilteredOlc = [...orgFilterOlc, ...userAllow];
      let uniqueCombinedFilteredOlc = Array.from(
        combinedFilteredOlc
          .reduce((map, item) => {
            if (item.condition && !map.has(item.condition)) {
              map.set(item.condition, item);
            }
            return map;
          }, new Map())
          .values()
      );

      // combinedFilteredOlc - userOlcDeny => cohortIds
      let userDeny = userOlc.deny || [];
      let cohortIds = uniqueCombinedFilteredOlc.filter(
        (allowItem) =>
          !userDeny.some(
            (denyItem) => denyItem.condition === allowItem.condition
          )
      );
      cohortIds = cohortIds.map(item => item.condition);
      this.$store.dispatch("updateCohortIds", cohortIds);
    },
    async extractImei() {
      const data = this.$store.getters.currentUserNode;
      if (data && data.hardwareGroups) {
        const imei = data.hardwareGroups[0].devices[0].props.find((el) => el.prop === "imei")?.val || "";
        return imei ? imei : '';
      }
      return '';
    },
    getSize(size) {
      if (size < 1000) {
        this.sizeUnit = 'kW';
        return size;
      } else if (size > 1000 && size < 1000000) {
        this.sizeUnit = 'MW';
        return (size / 1000).toFixed(2);
      } else if (size > 1000000) {
        this.sizeUnit = 'GW';
        return (size / 1000000).toFixed(2);
      } else {
        this.sizeUnit = 'kW';
        return size;
      }
    },
    getTotalSavings(totalSavings) {
      if (totalSavings < 1000) {
        return totalSavings.toFixed(0);
      } else if (totalSavings > 1000 && totalSavings < 1000000) {
        this.savingSuffix = 'k';
        return (totalSavings / 1000).toFixed(2);
      } else if (totalSavings > 1000000) {
        this.savingSuffix = 'm';
        return (totalSavings / 1000000).toFixed(2);
      }
    }
  },
};
</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');

.dark-home{
  background-color: var(--background-color-light);
}

.theme-toogle{
  background-color: #3d309e;
  padding: 5px 5px;
  color:var(--text-color-dark);
  padding:5px 10px;
  border-radius:10px;
}

.theme-toogle.dark-mode {
  color: var(--text-color-dark);

}
.home {
  padding: 10px;
  overflow-y: scroll;
  position: fixed;
  width: 100%;
  background-color: var(--background-color-light);
  z-index: 999999999;
}

.profile {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  font-family: var(--font-family);
}

.profile-no-button {
  justify-content: center;
  gap: 15px;
}

.change_sites {
  background: var(--primary-color-light);
  border: none;
  color: var(--text-color-dark);
  font-size: 12px;
  font-weight: 500;
  padding: 5px 5px;
  border-radius: 10px;
  font-family: var(--font-family);
}

.initials {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: var(--primary-color-light);
  font-family: var(--font-family);
  color: var(--text-color-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
}
.profile-info {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.profile-text {
  font-size: 15px;
  font-weight: 600;
  color: var(--primary-color-light);
}

.date {
  font-size: 12px;
  color: #575757;
  font-weight: 400;
}

.carousel-container {
  position: relative;
  width: 100%;
  margin-top: 70px;
}

.slide {
  position: relative;
  width: calc(100% - 40px);
  height: 150px;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-color-dark);
  text-align: center;
}

.slide-background {
  position: absolute;
  top: 0;
  right: 0;
  bottom: -16px;
  left: 0;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.slide-content {
  position: relative;
  left: 0;
  padding-left: 30px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.layout1 {
  flex-direction: column;
  align-items: start;
}

.layout2 {
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
}

@media (max-width: 1200px) {
  .layout2 {
    justify-content: flex-start;
  }
}

@media (min-width: 1200px) {
  .layout2 {
    justify-content: flex-start;
  }
}

.layout3 {
  flex-direction: row;
  justify-content: start;
  gap: 20px;
  padding: 10px;
}

.left-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.right-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.slide-text {
  position: relative;
  font-size: 14px;
  font-family: var(--font-family);
  font-weight: 600;
  padding: 10px;
  z-index: 1;
}

.slide-text span {
  color: var(--secondary-color-light);
}

.slide-text-left {
  font-size: 12px;
  padding: 4px 10px;
  z-index: 1;
  font-weight: 600;
  font-family: var(--font-family);
}

.slide-text-right {
  font-size: 20px;
  font-weight: 600;
  font-family: var(--font-family);
  padding: 0 10px;
  z-index: 1;
  text-align: left;
}

.partner {
  font-weight: 500;
  font-size: 10px;
  font-family: var(--font-family);
  text-align: left;
}

.slide-image {
  margin-top: 10px;
}

.dots {
  display: flex;
  justify-content: center;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: #E4E4E4;
  border-radius: 50%;
  margin: 0 2px;
  cursor: pointer;
}

.dot.active {
  background-color: var(--secondary-color-light);
}



.power_input {
  padding: 20px;
  background: linear-gradient(180deg, #F9F9F9 0%, #F2F2F2 100%);
  border-radius: 20px;
  margin-top: 20px;
}

.power_intro {
  font-size: 18px;
  color: var(--text-color-light);
  font-family: var(--font-family);
  font-weight: 600;
  text-align: left;
  margin: 0;
}

.power_date {
  font-size: 12px;
  font-weight: 400;
  color: var(--text-color-light);
  font-family: var(--font-family);
  text-align: left;
}

.smoke_image {
  background-color: #3b5036;
  border-radius: 50%;
  padding: 15px;
}

.leaf {
  padding: 15px 18px;
}

.planting {
  margin-top: -20px;
}

.status {
  display: flex;
  justify-content: space-between;
  padding: 17px 2px;
  background: linear-gradient(to right, #050011, #120B41);
  background: linear-gradient(-42.979deg, #1D0C47 0%, #050011 100%);
  border-radius: 20px;
}

.status_top {
  font-size: 12px;
  font-weight: 600;
  font-family: var(--font-family);
  text-align: left;
  padding: 0 10px;
  margin: 0 0 10px;
}

.status-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 10px 0;
  text-align: center;
  width: calc(100% / 3);
}

.border-line {
  position: absolute;
  width: 1px;
  height: 100%;
  background: linear-gradient(-42.979deg, #7F74D2 100%, #D6D1FF 100%);
  right: 0;
  top: 0;
  transform: translateX(50%);
}

.status-item:last-child .border-line {
  display: none;
}

.units_today {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-family: var(--font-family--inter);
  color: var(--text-color-dark);
  font-weight: 500;
  margin: 0;
}

.units_today span {
  font-weight: 400;
  line-height: 30px;
  padding-left: 5px;
  font-size: 10px;
  color: var(--text-color-dark);
  font-family: var(--font-family);
}

.today {
  font-size: 10px;
  color: var(--text-color-dark);
  font-weight: 400;
  font-family: var(--font-family);
  margin: 0;
}

.weather_intro {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding: 0 10px;
}

.weather_intro h2 {
  font-size: 12px;
  font-family: var(--font-family);
  font-weight: 600;
  margin: 0 0 10px;
}

.weather_intro p {
  font-size: 10px;
  font-weight: 400;
  margin: 0 0 10px;
  font-family: var(--font-family);
}

.weather-card-container {
  gap: 10px;
  columns: 2 6rem;
}

.weather-card-container > div:first-child {
  margin-top: 0;
}

.weather-card {
  display: flex;
  margin-top: 10px;
  width: 100%;
  flex-direction: row;
  text-align: center;
  background-color: #3187D6;
  border-radius: 15px;
  overflow: hidden;
  border: none;
  color: var(--text-color-dark);
}

.weather-card:nth-child(1) {
  background-color: #3187D6;
}

.weather-card:nth-child(2) {
  background-color: #000000;
}

.weather-card:nth-child(3) {
  background-color: #09CA97;
}

.weather-card:nth-child(4) {
  background-color: #041A6C;
}


.weather-card-left {
  display: flex;
  align-items: center;
  padding: 15px 10px 14px 15px;
}

.weather-image-container {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.weather-image-container img {
  max-width: 100%;
  max-height: 100%;
}

.weather-card-right {
  flex: 1;
  padding: 18px 0;
  text-align: left;
}

.weather-main-text {
  font-size: 20px;
  font-family: var(--font-family-inter);
  font-weight: 400;
  margin: 0;
}

.weather-sub-text {
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  font-family: var(--font-family);
  color: var(--text-color-dark);
}
.site_buttons {
  display: flex;
}
.plus_sites {
  color: var(--primary-color-light);
  font-weight: 600;
  font-family: var(--font-family);
}
.header-content {
  display: flex;
  height: 18vh;
  padding: 35px 20px;
}
.centralize-text {
  color: #fff;
  font-size: 28px;
  font-weight: bold;
  text-align: left;
  line-height: 1.2;
  font-family: 'Montserrat', sans-serif;
}
.green-text {
  color: #00f2b2;
}
.switch {
  font-size: 12px;
  position: relative;
  display: inline-block;
  width: 4em;
  height: 2.2em;
  border-radius: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.theme-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #453a94;
  transition: 0.4s;
  border-radius: 30px;
  overflow: hidden;
}

.theme-slider:before {
  position: absolute;
  content: "";
  height: 1.2em;
  width: 1.2em;
  border-radius: 20px;
  left: 0.5em;
  bottom: 0.5em;
  transition: 0.4s;
  transition-timing-function: cubic-bezier(0.81, -0.04, 0.38, 1.5);
  box-shadow: inset 8px -4px 0px 0px #fff;
}

.switch input:checked + .theme-slider {
  background-color: #453a94;
}

.switch input:checked + .theme-slider:before {
  transform: translateX(1.8em);
  box-shadow: inset 15px -4px 0px 15px #ffcf48;
}

.star {
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  width: 5px;
  transition: all 0.4s;
  height: 5px;
}

.star_1 {
  left: 2.5em;
  top: 0.5em;
}

.star_2 {
  left: 2.2em;
  top: 1.2em;
}

.star_3 {
  left: 3em;
  top: 0.9em;
}

.switch input:checked ~ .theme-slider .star {
  opacity: 0;
}

.cloud {
  width: 3.5em;
  position: absolute;
  bottom: -1.4em;
  left: -1.1em;
  opacity: 0;
  transition: all 0.4s;
}

.switch input:checked ~ .theme-slider .cloud {
  opacity: 1;
}
.add_site_btn{
  margin: 10px auto;
    background-color: #453A94;
    color: #fff;
    padding: 5px 20px;
    border-radius: 20px;
    font-size: 14px;
}
</style>


